import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core"
import Grid from '@material-ui/core/Grid'
import { useCreation, useSelections } from 'ahooks'
import Checkbox from "Components/Checkbox"
import ApiRequest from 'EurestoApi/ApiRequest'
import Bus from 'EurestoClass/Bus'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React, { useEffect, useMemo, useState } from 'react'
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"

const project = require('EurestoConfig/project.config')


const findOptionParent = (options, id) => {
  return Object.keys(options).reduce((option_id, key) => {
    key = parseInt(key)
    if (option_id) {
      return option_id
    }
    if (options[key] && options[key].children[id])
      return key
    return options[key] && (options[key].children[id] || findOptionParent(options[key].children, id)) ? key : undefined
  }, undefined)
}

const optionToObject = (options, option) => {
  if (!option.option_id) {
    options[option.id] = {
      ...(options[option.id] || {}),
      id: option.id,
      libelle: option.libelle,
      type: option.type,
      icon: option.icon,
      children: {}
    }
  } else {
    if (options[option.option_id]) {
      if (option.type === 2) {
        options[option.option_id] = {
          ...(options[option.option_id] || {}),
          options: {
            ...(options[option.option_id] && options[option.option_id].options || {}),
            [option.id]: {
              id: option.id,
              option_id: option.option_id,
              libelle: option.libelle,
              type: option.type,
              icon: option.icon,
            }
          }
        }
      } else {
        options[option.option_id] = {
          ...(options[option.option_id] || {}),
          children: {
            ...(options[option.option_id] && options[option.option_id].children || {}),
            [option.id]: {
              id: option.id,
              option_id: option.option_id,
              libelle: option.libelle,
              type: option.type,
              icon: option.icon,
              children: {},
              options: {},
            }
          }
        }
      }
    } else {
      const key = findOptionParent(options, option.option_id)
      if (key)
        options[key].children = optionToObject(options[key].children, option)
    }
  }

  return options
}

const reduceSubOptionToArray = (filter) => (options, option) => {
  options.push(option.id)
  const subOptions = Object.keys({ ...option.options || {}, ...option.children || {} })
    .map(k => option.children && option.children[k] || option.options && option.options[k])
    .filter(filter)
    .reduce(reduceSubOptionToArray(filter), []) || []
  if (subOptions && subOptions.length > 0)
    options.push(...subOptions)

  return options
}

const handleSelectionRadio = (value, options, selection) => {
  value = parseInt(value)
  options.map(o => o !== value && selection.selected.indexOf(o) !== -1 && selection.toggle(o))
  selection.toggle(value)
}

const handleDoubleClick = (value, options, selection) => {
  const toggleAction = selection.isSelected(value) ? 'unSelect' : 'select'
  options.map(o => selection[toggleAction](o))
  selection.toggle(value)
}

const showOptions = (disable, options, selection, margin, optionsSelection = [], isLast = false) => {
  console.log("SELECTION", selection)
  return Object.keys(options).map((key, i) => {

    let filter;

    const ooo = Object.keys(options[key].options || {}).length > 0 ?
      Object.keys(options[key].options).map(o => parseInt(o))
      : []

    if (Object.keys({ ...options[key].options || {}, ...options[key].children || {} }).length > 0) {
      const n = Object.keys({ ...options[key].options || {}, ...options[key].children || {} }).map(o => parseInt(o))
        .reduce((r, o) => selection.selected.indexOf(options[key].id) === -1 &&
          (r || selection.selected.indexOf(o) !== -1 && o) || undefined, undefined)
      if (n) {
        selection.toggle(options[key].id)
      }
    }

    const value = ooo.reduce((r, o) => r || selection.selected.indexOf(o) !== -1 && o || undefined, undefined)

    const isSelected = selection.isSelected(options[key].id)
    const isChildrenAvailable = Object.keys({ ...options[key].options || {}, ...options[key].children || {} }).length > 0

    let subOptions = []

    if (isChildrenAvailable) {
      filter = (o) => isSelected && o.type === 2 || o.type === 3
      subOptions = Object.keys({ ...options[key].options || {}, ...options[key].children || {} }).map(k => options[key].children && options[key].children[k] || options[key].options && options[key].options[k]).filter(filter).reduce(reduceSubOptionToArray(filter), [])
    }

    return <Grid
      key={'key-' + key + '-' + i + '-' + (value || "")}
      className={!disable && 'cursor-pointer' || 'cursor-not-allowed'}
      direction={"column"}
      container style={{
        margin: 0,
        padding: margin === 0 && "0px 0px 7.5px 0px" || 0,
        marginTop: margin === 0 && 10,
        marginLeft: margin,
        width: `calc(100% - 15px)`,
        alignItems: 'end',
      }} spacing={0}>
      {
        options[key].type === 1 && <Grid alignItems={"center"} alignContent={"center"} container className={`EurestoPrimary EurestoText--text`} justify={"center"} style={{ fontWeight: 'bold', margin: margin && `2.5px 0px 0px 0px`, padding: margin === 0 && 10 || 2.5, width: '100%', border: '1px solid black', borderRadius: 5 }} spacing={0}>
          {options[key].libelle}
        </Grid>
        || options[key].type === 2 && <Grid alignContent={"end"}
          onClick={(e) => {
            !disable && handleSelectionRadio(options[key].id, optionsSelection, selection)
          }} alignItems={"end"} justify={"space-between"} container
          style={{
            margin: margin ? "5px 0px 0px 0px" : 0,
            padding: 2.5,
            width: '100%',
            fontWeight: isSelected && 'bold' || 'normal'
          }} spacing={0}>
          <Grid style={{ width: 'calc(100% - 25px)' }}>
            <Grid container justify={"end"} alignItems={"end"}>
              <Grid>{options[key].libelle}</Grid>
            </Grid>
          </Grid>
          <FormControlLabel style={{ margin: 0 }} value={options[key].id} control={<Radio />} />
        </Grid>
        || options[key].type === 3 && <Grid
          alignContent={"end"}
          onDoubleClick={(event) => {
            isChildrenAvailable && handleDoubleClick(options[key].id, subOptions, selection)
            event.stopPropagation()
            event.preventDefault()
          }}
          onClick={() => !disable && selection.toggle(options[key].id)}
          alignItems={"center"} justify={"space-between"}
          className={isChildrenAvailable && !margin && `EurestoPrimary EurestoText--text`}
          container style={{
            margin: margin ? "5px 0px 0px 0px" : 0,
            borderRadius: !margin && '5px',
            borderBottom: isChildrenAvailable && '1px solid black',
            padding: 2.5,
            width: '100%',
            fontWeight: isSelected && 'bold' || 'normal'
          }}
          spacing={0}>
          <Grid style={{ width: 'calc(100% - 25px)' }}>
            <Grid container justify={"end"} alignItems={"center"}>
              <Grid>{options[key].libelle}</Grid>
            </Grid>
          </Grid>
          <Checkbox disable={disable} color={'secondary'}
            checked={isSelected} />
        </Grid>
      }
      {isChildrenAvailable && <React.Fragment>
        {options[key].children && Object.keys(options[key].children).length > 0
          && showOptions(disable, options[key].children, selection, 5 + margin, [], options.length === (i + 1))}
        {options[key].options && Object.keys(options[key].options).length > 0
          && <RadioGroup style={{ width: '100%', alignItems: 'end' }} disable={disable} value={value} aria-label={"customized-radios-" + options[key].id} name={"customized-radios-" + options[key].id}>
            {showOptions(disable, options[key].options, selection, 5 + margin, ooo, options.length === (i + 1))}
          </RadioGroup>}
      </React.Fragment>}
    </Grid>
  })
}

const saveConfig = async (options, id) => {
  await ApiRequest(project.api + 'configuration', {
    requete: 'option',
    action: 'set',
    entite_id: id,
    options: options
  })
}

export default React.memo(props => {

  const key = useCreation(() => Utils.uuidv4(), []);

  const [save, setSave] = useState(false)

  useEffect(() => {
    Bus.$on('save_options_contacts_' + props.contact_id, async _ => {
      setSave(true)
    }, key)
    return () => Bus.$off('save_options_contacts_' + props.contact_id, key)
  }, [selectionOptions])

  useEffect(() => {
    (async () => {
      if (save) {
        await saveConfig(selectionOptions.selected, props.contact_id)
        props.onSaveOptions(selectionOptions.selected)
        setSave(false)
      }
    })()
  }, [save])

  const rowsOptions = useMemo(() => Data.list(Constants.module.COMMUN, Constants.donnee.option, {
    actif: { or: [1, 3] }
  })
    , [])

  const options = useMemo(() => rowsOptions.map(option => option.id), [rowsOptions]);

  const selectionOptions = useSelections(options, props.options || []);

  const opts = useMemo(() => rowsOptions.reduce(optionToObject, {}), [rowsOptions])
  console.log("###########", opts)


  return <Grid container style={{ margin: 0, padding: 0, height: '100%', width: '100%' }} spacing={8}>
    <Grid
      direction={"column"}
      container style={{
        padding: "0px 5px 0px 5px",
        width: `50%`,
      }} spacing={0}>
      <Grid alignItems={"center"} alignContent={"center"} container className={`EurestoPrimary EurestoText--text`} justify={"center"} style={{ fontWeight: 'bold', padding: 10, width: '100%', border: '1px solid black', borderRadius: 5 }} spacing={0}>
        Euresto
      </Grid>
      <ResponsiveMasonry style={{ width: '100%' }}
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 3 }}
      >
        <Masonry style={{ justifyContent: 'center' }}>
          {showOptions(props.action_option === 'view', opts[1000].children, selectionOptions, 0)}
        </Masonry>
      </ResponsiveMasonry>
    </Grid>
    <Grid
      direction={"column"}
      container style={{
        padding: "0px 5px 0px 5px",
        width: `50%`,
      }} spacing={0}>
      <Grid alignItems={"center"} alignContent={"center"} container className={`EurestoPrimary EurestoText--text`} justify={"center"} style={{ fontWeight: 'bold', padding: 10, width: '100%', border: '1px solid black', borderRadius: 5 }} spacing={0}>
        Interfaces
      </Grid>
    <ResponsiveMasonry style={{ width: '100%' }}
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 3 }}
    >
      <Masonry>
          {showOptions(props.action_option === 'view', opts[3000].children, selectionOptions, 0)}
      </Masonry>
      </ResponsiveMasonry>
    </Grid>
  </Grid>
})


// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Options/index2.js